import { PageHead, Card, Pill, EmptyState } from '../ui/primitives';

export default function Inbox() {
  return (
    <div className="max-w-4xl mx-auto">
      <PageHead title="Aiko Inbox" sub="Things she noticed that you should look at" />
      <div className="px-5 md:px-8">
        <Card>
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-accent grid place-items-center text-bg font-semibold">A</div>
            <div className="min-w-0">
              <div className="font-medium">Inbox is wired to the autonomous sweep (cron every 15 min)</div>
              <div className="text-sm text-muted mt-1">
                When the autonomous loop ships in STAGE 6, this is where suggestions land:
              </div>
              <ul className="mt-3 space-y-2 text-sm">
                <li className="flex items-start gap-2"><Pill tone="warn">lead</Pill><span>Stale leads (no contact in 3d) — draft a follow-up.</span></li>
                <li className="flex items-start gap-2"><Pill tone="danger">repair</Pill><span>Repair ticket open &gt;1d untriaged — propose a mechanic + ETA.</span></li>
                <li className="flex items-start gap-2"><Pill tone="warn">cert</Pill><span>Cert expiring in 30d — generate renewal reminder.</span></li>
                <li className="flex items-start gap-2"><Pill tone="muted">fleet</Pill><span>Asset idle &gt;14d — flag for the sales pipeline.</span></li>
              </ul>
            </div>
          </div>
        </Card>
        <div className="mt-4">
          <EmptyState title="No suggestions yet" hint="The /15-minute cron job runs after deploy. Items will accumulate here." />
        </div>
      </div>
    </div>
  );
}
